import { Skeleton, Stack, Group } from '@mantine/core';

/**
 * Boshlang'ich yuklanish — konteyner O'RNIGA skelet.
 *
 * Avval bu joylarda `<Center h={300}><Loader /></Center>` turardi: butun maydon
 * bo'shab, o'rtada bitta spinner aylanardi. Uch kamchiligi bor edi:
 *  • nima yuklanayotgani ko'rinmasdi — sahifa "sindi"mi yoki yuklanyaptimi,
 *    farqi bilinmasdi;
 *  • ma'lumot kelganda layout SAKRARDI (300px markazdan to'liq jadvalga);
 *  • sahifa tuzilishi haqida hech qanday tasavvur bermasdi.
 *
 * Skelet uchalasini ham yopadi: taxminiy shakl darhol ko'rinadi, ma'lumot
 * kelganda joyiga tushadi va sakrash bo'lmaydi.
 *
 * `variant`:
 *   'table' — qatorli ro'yxatlar (jadval, xodimlar, o'quvchilar)
 *   'card'  — kartochka sahifalari (bitta yozuv tafsiloti)
 *   'form'  — forma bloklari
 */
export function BlockLoader({
  variant = 'table',
  rows = 6,
}: {
  variant?: 'table' | 'card' | 'form';
  rows?: number;
}) {
  if (variant === 'card') {
    return (
      <Stack gap="md" aria-busy="true">
        <Group gap="md" wrap="nowrap">
          <Skeleton height={54} circle />
          <Stack gap={8} style={{ flex: 1 }}>
            <Skeleton height={18} width="35%" radius="sm" />
            <Skeleton height={12} width="22%" radius="sm" />
          </Stack>
        </Group>
        <Group gap="md" grow>
          {Array.from({ length: 3 }, (_, i) => <Skeleton key={i} height={72} radius="md" />)}
        </Group>
        <Skeleton height={180} radius="md" />
      </Stack>
    );
  }

  if (variant === 'form') {
    return (
      <Stack gap="sm" aria-busy="true">
        {Array.from({ length: rows }, (_, i) => (
          <Stack key={i} gap={6}>
            <Skeleton height={11} width="18%" radius="sm" />
            <Skeleton height={34} radius="sm" />
          </Stack>
        ))}
      </Stack>
    );
  }

  return (
    <Stack gap="xs" aria-busy="true">
      {/* Sarlavha qatori — qolganidan kalta, jadval boshi ekani bilinsin */}
      <Skeleton height={13} width="28%" radius="sm" mb={4} />
      {Array.from({ length: rows }, (_, i) => (
        <Group key={i} gap="md" wrap="nowrap">
          <Skeleton height={34} style={{ flex: 3 }} radius="sm" />
          <Skeleton height={34} style={{ flex: 2 }} radius="sm" visibleFrom="sm" />
          <Skeleton height={34} style={{ flex: 1 }} radius="sm" visibleFrom="md" />
        </Group>
      ))}
    </Stack>
  );
}
